import React from "react";

import FileUploadPane, {
  FileUploadPaneConfig,
} from "src/app/components/FileUploadPane/FileUploadPane";

import "./AddAIBriefPane.scss";

const AI_BRIEF_CONFIG: FileUploadPaneConfig = {
  title: {
    id: "ws_add_ai_brief_title",
    defaultMessage: "Adding brief for AI",
  },
  description: {
    id: "ws_add_ai_brief_description",
    defaultMessage:
      "Upload a brief or write requirements manually. AI will analyze this file and use it as requirements for this campaign.",
  },
  textareaLabel: {
    id: "ws_campaign_requirements",
    defaultMessage: "Campaign requirements",
  },
  textareaTooltip: {
    id: "ws_campaign_requirements_tooltip",
    defaultMessage:
      "Describe your campaign goals, creator requirements, platforms, formats, and any must-haves",
  },
  textareaPlaceholder: {
    id: "ws_campaign_requirements_placeholder",
    defaultMessage:
      "Describe your campaign goals, creator requirements, platforms, formats, and any must-haves",
  },
  acceptedFileTypes: {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
      ".docx",
    ],
    "text/plain": [".txt"],
  },
  maxFileSizeMB: 300,
};

interface AddAIBriefPaneProps {
  onClose: () => void;
  handleUploadFile: (file: File) => Promise<string | undefined>;
  handleRemoveFile: (onSuccess: () => void) => void;
  handleSaveRequirements: (requirements: string) => void;
  briefContent: string;
  briefName: string;
  briefUrl?: string;
  isLoading: boolean;
}

export default function AddAIBriefPane({
  onClose,
  handleUploadFile,
  handleRemoveFile,
  handleSaveRequirements,
  briefContent,
  briefName,
  briefUrl,
  isLoading,
}: AddAIBriefPaneProps) {
  return (
    <FileUploadPane
      config={AI_BRIEF_CONFIG}
      onClose={onClose}
      handleUploadFile={handleUploadFile}
      handleRemoveFile={handleRemoveFile}
      handleSaveContent={handleSaveRequirements}
      content={briefContent}
      fileName={briefName}
      fileUrl={briefUrl}
      isLoading={isLoading}
      className="add-ai-brief-pane"
      backdropClassName="add-ai-brief-pane__backdrop"
      width={500}
    />
  );
}
